/*
 * @Author: sipeng
 * @LastEditTime: 2022-09-08 10:21:02
 * @Description:
 * @LastEditors: Please set LastEditors
 */
export default {
  sourceFile: 'Source File',
  fileName: 'File Name',
  queryFile: 'Query File',
  state: 'State',
  uploader: 'Uploader',
  uploadDate: 'Upload Date',
  objectRegistrationRecord: 'Object Registration Record',
  category: 'Category',
  queryTagCodeOrTagName: 'Query Tag Code or Tag Name',
  objectEncoding: 'Object Encoding',
  superior: 'Superior',
  objectName: 'Object Name',
  describe: 'Describe',
  pleaseSelectTheSourceFileFirst: 'Please Select The Source File First',
}
